import React from "react";
import { AssetInterface } from "src/store/mine_craft/assetsSlice";
import { UserInterface } from "src/store/mine_craft/usersSlice";
import CardImage from "../../../../componets/CardImage";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { setEditId } from "../../../../store/mine_craft/assetsSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyAsset } from "../../../../actions/mine_craft/assetsActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import Meta from "../../../mine_craft/Users/_partials/_Meta";

interface propsInterface {
  asset: AssetInterface;
  user?: UserInterface | undefined;
}

const Card = ({ asset, user }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formattedCreatedAt = formattedDate(asset.created_at);

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={'v-mine_craft-assets__card'}
      image={asset.image_url}
      size='medium'
      options={[
        <ButtonEdit key={`edit-${asset.id}`} onClick={() => onClickEdit(asset.id)} />,
        <ButtonDestroy key={`destroy-${asset.id}`} onClick={() => onClickDestroy(asset.id)} />
      ]}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
